<template>
    <!-- 樣式：各項變更說明條款 -->
    <div
        class="white-box"
        :class="[hasTitle&&'white-box-no-tab'] "
    >
        <Title
            v-if="hasTitle"
            :text="$route.meta.pageTitle"
            style-code-page
        />
        <div class="border-t border-b border-gray-100 text-base mb-7 pt-4 pb-2 md:py-5 text-gray-900">
            <transition
                name="opacity"
                mode="out-in"
            >
                <div
                    v-if="!content.length"
                    class="overflow-hidden"
                >
                    <SkeletonTerm
                        v-for="n in 2"
                        :key="n"
                    />
                </div>
                <div
                    v-else
                    class="terms"
                    v-html="content"
                />
            </transition>
        </div>
        <div class="flex justify-center">
            <button
                class="btn text-base gradient-primary border-0 rounded-full py-3 px-11"
                :disabled="!content.length"
                @click="goNext"
            >
                確定
            </button>
        </div>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import SkeletonTerm from '@/components/skeletons/SkeletonTerm.vue';
import Loading from '@/components/Loading.vue';
import Title from '@/components/text/Title.vue';

export default {
    components: {
        SkeletonTerm,
        Loading,
        Title
    },
    props: {
        content: {
            type: String,
            default: ''
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        hasTitle: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['goNext'],
    setup(props, { emit }) {
        const goNext = () => {
            emit('goNext');
        };
        return {
            goNext,
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(.terms) {
    ul {
        @apply ml-6;
        li {
            margin-bottom: 0.3rem;
        }
    }
}
</style>
